import DiscountsPanel from "./DiscountsPanel";

export type {
    IDiscountsPanel as IProps,
    IDiscountsPanelResult as Result,
    IDiscountsPanelViewState as State,
} from "./DiscountsPanel";

export default DiscountsPanel;
